import React, { useMemo } from 'react'
import { dataCatalog } from '../../../../../api/coreData'
import Loading from '../../../../../components/molecules/Loading'
import FlexRow from '../../../../../components/molecules/FlexRow'
import CatalogListItem from './CatalogListItem'

function CatalogList () {
  const { data, isLoading } = dataCatalog.useListCatalogDataSources()
  const catalog = useMemo(() => {
    if (!data?.sources?.length) {
      return {
        tables: [],
        aiTables: [],
        pipelines: [],
        aiPipelines: []
      }
    }

    const allTables = data.sources.filter(s => s.type === 'table')
    const allPipelines = data.sources.filter(s => s.type === 'api')

    const aiTables = allTables.filter(s => s.isAiEnabled)
    const aiPipelines = allTables.filter(s => s.isAiEnabled)

    return {
      tables: allTables,
      aiTables,
      pipelines: allPipelines,
      aiPipelines
    }
  }, [data])

  if (isLoading) {
    return (
      <Loading />
    )
  }

  return (
    <FlexRow className='gap-lg flex-wrap'>
      {!catalog.aiTables.length ? (
        <div>No Catalog Data Available</div>
      ) : null}
      {catalog.aiTables.map(t => (
        <CatalogListItem
          key={`cds_${t.catalogDatasourceId}`}
          {...t}
        />
      ))}
    </FlexRow>
  )
}

export default CatalogList
